var exports = {
  "R7": "completedIcon__Ce3Mof",
  "Qr": "animatedCircle__k9XTIJ",
  "bO": "circleProgressShade__texKT4",
  "td": "ringSvg__dOm2K1",
  "n1": "circle__XH4-FL",
  "iv": "circleProgress__fmdEwm",
};

module.exports = exports;
